import { InputsNS } from '@/types/inputs';
import { useMemo } from 'react';

export function useInputStyle(type: InputsNS.StatusType = InputsNS.StatusType.Informative) {
  const border = useMemo(
    () => ({
      'border-base-dark-grey': type === InputsNS.StatusType.Disabled,
      'border-feedback-success-500': type === InputsNS.StatusType.Success,
      'border-feedback-warning-500': type === InputsNS.StatusType.Warning,
      'border-feedback-negative': type === InputsNS.StatusType.Error,
      'border-base-grey': type === InputsNS.StatusType.Informative,
    }),
    [type]
  );
  const focusBorder = useMemo(
    () => ({
      'focus:border-feedback-success-500': type === InputsNS.StatusType.Success,
      'focus:border-feedback-warning-500': type === InputsNS.StatusType.Warning,
      'focus:border-feedback-negative': type === InputsNS.StatusType.Error,
      'focus:border-interactive-black': type === InputsNS.StatusType.Informative,
    }),
    [type]
  );

  return { border, focusBorder };
}

export function useCheckboxStyle(
  type: InputsNS.StatusType = InputsNS.StatusType.Informative,
  disabled: boolean = false
) {
  return useMemo(
    () => ({
      '!border-base-grey cursor-not-allowed': disabled,
      'cursor-pointer border-interactive-black': !disabled,
      '!border-interactive-black bg-interactive-black outline-interactive-black':
        type === InputsNS.StatusType.Informative && !disabled,
      '!border-feedback-warning-500 bg-feedback-warning-500 outline-feedback-warning-500':
        type === InputsNS.StatusType.Warning && !disabled,
      '!border-feedback-success-500 bg-feedback-success-500 outline-feedback-success-500':
        type === InputsNS.StatusType.Success && !disabled,
      '!border-feedback-negative bg-feedback-negative outline-feedback-negative':
        type === InputsNS.StatusType.Error && !disabled,
    }),
    [disabled, type]
  );
}
